import {
    secureGet,
    securePost,
    securePut,
    secureDelete,
} from '../../Config/ApiConfig';

export const ContactsServices = {
    /**
     * Get all contacts
     * @param {Object} params - Query parameters (pagination, search, filters, sort)
     * @returns {Promise} API response
     */
    getContacts: async (params) => {
        const queryParams = new URLSearchParams();
        if (params.page) queryParams.append('page', params.page);
        if (params.size) queryParams.append('page_size', params.size);
        if (params.search) queryParams.append('search_string', params.search);

        // Handle filters object
        if (params.filters) {
            queryParams.append('filters', JSON.stringify(params.filters));
        }

        if (params.sort_by) queryParams.append('sort_by', params.sort_by);
        if (params.sort_direction) queryParams.append('sort_direction', params.sort_direction);

        const { data } = await secureGet(`/contacts?${queryParams.toString()}`, params.signal ? { signal: params.signal } : {});
        return data;
    },

    /**
     * Get contact by ID
     * @param {string} id - Contact ID
     * @returns {Promise} API response
     */
    getContactById: async (id) => {
        const { data } = await secureGet(`/contacts/${id}`);
        return data;
    },

    /**
     * Update contact
     * @param {string} id - Contact ID
     * @param {Object} body - Update data
     * @returns {Promise} API response
     */
    updateContact: async (id, body) => {
        const { data } = await securePut(`/contacts/${id}`, body);
        return data;
    },

    /**
     * Delete contact
     * @param {string} id - Contact ID
     * @returns {Promise} API response
     */
    deleteContact: async (id) => {
        const { data } = await secureDelete(`/contacts/${id}`);
        return data;
    },

    /**
     * Delete contact's profile picture
     * @param {string} id - Contact ID
     * @returns {Promise} API response
     */
    deleteContactProfilePicture: async (id) => {
        const { data } = await secureDelete(`/contacts/${id}/profile-picture`);
        return data;
    },

    /**
     * Get or create conversation for a contact
     * @param {string} id - Contact ID
     * @returns {Promise} API response with conversation
     */
    getContactConversation: async (id) => {
        const { data } = await secureGet(`/contacts/${id}/conversation`);
        return data;
    },
};

export default ContactsServices;
